export const TO_DROP_DOWN_OPTIONS: string[] = [
  'Al Mabaila Industrial Area',
  'Wadi Al Kabir Industrial Area',
  'Ghala Industrial Area',
  'Qurayyat Industrial Area',
  'Al Amerat Industrial Area',
  'Al Atkiyah – Al Amerat Industrial Area',
  'Barka Industrial Area',
  'Sandan Industrial Area',
  'Al Musannah Industrial Area',
  'Al Rustaq Industrial Area',
  'Nakhal Industrial Area',
  'Al Suwaiq Industrial Area',
  'Saham Industrial Area',
  'Al Khabourah Industrial Area',
  'Sohar Industrial Area',
  'Shinas Industrial Area',
  'Al Buraimi Industrial Area',
  'Al Tayyib – Ibri Industrial Area',
  'Ibri Industrial Area',
  'Al Homaniah Industrial Area',
  'Yanqul Industrial Area',
  'Dhank Industrial Area',
  'Karsha – Nizwa Industrial Area',
  'Izki Industrial Area',
  'Hay Al Saad – Bahla Industrial Area',
  'Adam Industrial Area',
  'Haima Industrial Area',
  'Thumrait Industrial Area',
  'Awqad Industrial Area',
  'Salalah Workshops Industrial Area',
  'Mahout Industrial Area',
  'Al Ashkharah Industrial Area',
  'Jaalan Bani Bu Ali Industrial Area',
  'Al Kamil & Al Wafi Industrial Area',
  'Sur Industrial Area',
  'Bidiyah Industrial Area',
  'Ibra Industrial Area',
  'Al Mudhaibi Industrial Area',
  'Sinaw Industrial Area',
  'Al Jardaa Repair Workshops',
  'Fanja Industrial Area',
  'Bidbid Industrial Area',
  'Hassas – Samail Industrial Area',
  'Samad Al Shaan Industrial Area',
  'Nearest Authorized Repair Workshop',
  'Nearest Tire Replacement Workshop',
  'Nearest Fuel Station',
  'Vehicle Door Unlocked On Site',
  'Tire Changed On Site',
  'Fuel Supplied On Site',
  'Duqm Industrial Area',
  'Al Mazyunah Industrial Area',
  'Khasab Industrial Area',
  'Madha Industrial Area',
  'Taqah Industrial Area',
  'Mirbat Industrial Area',
  'Shalim & Hallaniyat Islands Industrial Area',
  'Liwa Industrial Area',
  'Musandam Industrial Area',
  'Wadi Bani Khalid Industrial Area',
  'Dama & Al Taaiyin Industrial Area',
  'Al Khadra – Izki Industrial Area',
  'other',
];

